import { createFileRoute, Outlet, useRouterState } from '@tanstack/react-router';
import { AuthLayout } from '@/modules/auth/components/AuthLayout';
import { ProductBrandedAuthLayout } from '@/modules/auth/components/ProductBrandedAuthLayout';
import { ProductAuthBrandingProvider } from '@/modules/auth/context/ProductAuthBrandingContext';
import { useProductAuthBranding } from '@/modules/auth/hooks/useProductAuthBranding';

export const Route = createFileRoute('/auth')({
  component: AuthLayoutRoute,
});

function AuthLayoutRoute() {
  const branding = useProductAuthBranding();
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const isLoginRoute = pathname.endsWith('/login');

  const content =
    isLoginRoute && branding ? (
      <ProductBrandedAuthLayout branding={branding.branding} locale={branding.locale}>
        <Outlet />
      </ProductBrandedAuthLayout>
    ) : (
      <AuthLayout>
        <Outlet />
      </AuthLayout>
    );

  return (
    <ProductAuthBrandingProvider value={isLoginRoute ? branding : null}>
      {content}
    </ProductAuthBrandingProvider>
  );
}
